import {
  CREATE_SUBSCRIPTION_PENDING,
  CREATE_SUBSCRIPTION_FAIL,
  CREATE_SUBSCRIPTION_SUCCESS,
  UPDATE_SUBSCRIPTION_PENDING,
  UPDATE_SUBSCRIPTION_FAIL,
  UPDATE_SUBSCRIPTION_SUCCESS,
  GET_SUBSCRIPTIONS,
  GET_CHARGEBEE_SUBSCRIPTION,
} from '../actions/subscriptionActions';


const initialState = {
  subscription: {
    loading: true,
    loaded: false,
    error: false,
    account: '',
    gateway_uid: '',
    status: '',
    products: '',
    subscription_type: '',
    created_date: '',
    chargebee_data: {},
  },
  subscriptions: {
    loading: false,
    loaded: true,
    results: [],
  },
};


export const subscriptionReducer = (state = initialState.subscription, action) => {
  switch (action.type) {
    case CREATE_SUBSCRIPTION_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case CREATE_SUBSCRIPTION_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case CREATE_SUBSCRIPTION_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_SUBSCRIPTION_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case UPDATE_SUBSCRIPTION_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_SUBSCRIPTION_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_CHARGEBEE_SUBSCRIPTION.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case GET_CHARGEBEE_SUBSCRIPTION.error:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    case GET_CHARGEBEE_SUBSCRIPTION.success:
      return {
        ...state,
        loading: false,
        loaded: true,
        chargebee_data: action.payload.data,
      };
    default:
      return state;
  }
};


export const subscriptionsReducer = (state = initialState.subscriptions, action) => {
  switch (action.type) {
    case GET_SUBSCRIPTIONS.pending:
      return {
        loading: true,
        loaded: false,
        ...state,
      };
    case GET_SUBSCRIPTIONS.error:
      return {
        loading: false,
        loaded: true,
        ...state,
      };
    case GET_SUBSCRIPTIONS.success:
      return {
        loading: false,
        loaded: true,
        results: action.payload.data,
      };
    default:
      return state;
  }
};
